/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取项目服务弹窗
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetServicePopupInfoParams {
  constructor(
    public distributionChannelId?: string,
    public distributionSeriesId?: string
  ) {}
}

export default async function (
  productId: number,

  params: GetServicePopupInfoParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.ServicePopupDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/project/ServicePopup/${productId}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
